import { VERIFIED_STATUSES } from 'const/kyc'
import { KycStatus } from 'types/gql-global-types'

export const getIsVerified = (kycStatus: KycStatus) =>
  VERIFIED_STATUSES.includes(kycStatus)
